<template>
    <div class="booking-bulk-setting" v-loading="loadingListBookingTable">
        <div class="switch-bulk-setting pl-25">
            <div @click="handleClickBulkForm()" v-show="!showBulkSettingForm"
                class="button success">受付枠の一括設定を開く</div>
            <div @click="handleCloseBulkForm()" v-show="showBulkSettingForm"
                 class="button default">受付枠の一括設定をキャンセル</div>
        </div>
        <div class="booking-bulk-setting-form pl-25" style="position: relative"
            v-show="showBulkSettingForm">
            <div class="p-15">
                この「一括設定」機能では、指定した「日」もしくは「週」の受付枠設定状況を一括でコピーできます。
                <p>
                ＜この機能の使用例＞<br>
                （１）月曜日の受付枠の設定後、日単位の一括コピーでその週の営業日に対して設定を一括で設定する。<br>
                （２）上記「（１）」にて1週間の設定が完了した後、週単位の一括コピーで次週以降の受付枠設定を一括で設定する。
                </p>
            </div>
            <div class="setting-form mb-15">
                <img src="../assets/icon/arrow-right-circle.png" alt="">
                コピー単位の選択：

                <el-select
                    class="select default margin-auto mb-0"
                    v-model="bulkType"
                    @change="changeBulkType()"
                    placeholder="選択してください "
                    >
                    <el-option v-for="item in ['日単位', '週単位', ]" :key="item" :label="item" :value="item"/>
                </el-select>
            </div>
            <div id="selectedDayUnit" v-show="showBulkTypeDay">
                <div class="setting-form mb-15">
                    <img src="../assets/icon/arrow-right-circle.png" alt="">
                    コピー元の指定：

                    <input class="input h-44 p-15" name="originDate" @focus="handleClickHelpCalendarModal('originDate')"
                      v-model="originDate" size="10">
                </div>
                <div class="setting-form mb-15">
                    <img src="../assets/icon/arrow-right-circle.png" alt="">
                    コピー先の指定：

                    <input class="input h-44 p-15" name="targetStartDate" @focus="handleClickHelpCalendarModal('targetStartDate')" v-model="targetStartDate" size="10">
                    ～
                    <input class="input h-44 p-15" name="targetEndDate" @focus="handleClickHelpCalendarModal('targetEndDate')" v-model="targetEndDate" size="10">
                </div>
            </div>
            <div id="selectedWeekUnit" v-show="showBulkTypeWeek">
                <div class="setting-form mb-15">
                    <img src="../assets/icon/arrow-right-circle.png" alt="">
                    コピー元の指定：

                    <input class="input h-44 p-15" name="originDate" @focus="handleClickHelpCalendarModal('originDateForWeek')"
                      v-model="originDateForWeek" size="10">の週
                </div>
                <div class="setting-form mb-15">
                    <img src="../assets/icon/arrow-right-circle.png" alt="">
                    コピー先の指定：

                    <input class="input h-44 p-15" name="targetStartDate" @focus="handleClickHelpCalendarModal('targetWeekDate')"
                      v-model="targetWeekDate" size="10">の週から
                    <el-select
                        class="select default margin-auto mb-0"
                        v-model="weekCount"
                        >
                        <el-option v-for="item in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="item" :label="item" :value="item"/>
                    </el-select>週間分
                </div>
            </div>
            <div class="container-370 text-center">
                <!--<span @click="handleRemoveSelectedBooking()" class="cancel button w-175 default">繰り返し保存しない</span>-->
                <span @click="handleBulkCopyBooking()"
                  class="save button success w-250 mb-10 ml-10">設定した条件で一括設定する</span>
                <p class="p-10 text-left">
                    ※コピー先として指定した期間にすでに受付枠が設定されていた場合、もともと設定されていた内容は破棄され、コピー元に指定した内容で上書き設定されます。
                    <br>
                    ※指定期間にすでに予約が入っていた場合、予約が入っている受付枠は上書きされず無視されます。
                </p>
            </div>
            <hr class="mb-25">
        </div>
        <div class="modal-overlay" v-if="showModal">
            <div class="modal">
            <div class="modal-header">
                <div @click="handlecloseHelpCalendarModal()" class="button default">X 閉じる</div>
            </div>
            <div class="modal-body">
                <Calendar @dateChanged="dateChanged"
                  :init-date="originDateCalc()" :auto-set-today="false"
                  :pharmacy="pharmacy" :meeting="{start_at: originDateCalc()}"></Calendar>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import CalendarApi from '@/api/calendar'
import {apiErrorDialog} from '@/helpers'
import Calendar from '@/components/Calendar'
import _ from 'lodash'

export default {
  components: {Calendar},
  props: {
    pharmacy: {type: Object, default: () => { return {} }},
    firstDayOfWeek: {type: String, default: () => { return '' }},
    isChanged: {type: Boolean, default: () => { return false }}
  },
  data () {
    const originDate = this.calcMonthDate(moment(this.firstDayOfWeek)).format('Y-MM-DD')
    return {
      loadingListBookingTable: false,
      BULKTYPE_DAY: '日単位',
      BULKTYPE_WEEK: '週単位',
      updateColumnName: null,
      showBulkSettingForm: false,
      showModal: false,
      bulkType: '',
      showBulkTypeDay: false,
      showBulkTypeWeek: false,
      originDate,
      originDateForWeek: originDate,
      targetStartDate: moment(originDate).add(1, 'd').format('Y-MM-DD'),
      targetEndDate: moment(originDate).add(6, 'd').format('Y-MM-DD'),
      targetWeekDate: moment(originDate).add(7, 'd').format('Y-MM-DD'),
      weekCount: 1,
      originWeeks: [
        moment(originDate).add(-14, 'd').format('Y-MM-DD') + ' ～ ' + moment(originDate).add(-8, 'd').format('Y-MM-DD'),
        moment(originDate).add(-7, 'd').format('Y-MM-DD') + ' ～ ' + moment(originDate).add(-1, 'd').format('Y-MM-DD'),
        moment(originDate).format('Y-MM-DD') + ' ～ ' + moment(originDate).add(6, 'd').format('Y-MM-DD'),
        moment(originDate).add(7, 'd').format('Y-MM-DD') + ' ～ ' + moment(originDate).add(13, 'd').format('Y-MM-DD'),
        moment(originDate).add(14, 'd').format('Y-MM-DD') + ' ～ ' + moment(originDate).add(20, 'd').format('Y-MM-DD')
      ]
    }
  },
  methods: {
    calcMonthDate (date) {
      const weekindex = date.format('d')
      return _.cloneDeep(date.add(-1 * (weekindex - 1), 'd'))
    },
    originDateCalc () {
      if (this.bulkType === this.BULKTYPE_DAY) {
        if (this.updateColumnName === 'originDate') {
          return moment(this.originDate)
        } else if (this.updateColumnName === 'targetStartDate') {
          return moment(this.targetStartDate)
        } else if (this.updateColumnName === 'targetEndDate') {
          return moment(this.targetEndDate)
        }
      } else {
        if (this.updateColumnName === 'originDateForWeek') {
          return moment(this.originDateForWeek)
        } else if (this.updateColumnName === 'targetWeekDate') {
          return moment(this.targetWeekDate)
        }
      }
    },
    changeBulkType () {
      if (this.bulkType === this.BULKTYPE_DAY) {
        this.showBulkTypeDay = true
        this.showBulkTypeWeek = false
      } else if (this.bulkType === this.BULKTYPE_WEEK) {
        this.showBulkTypeDay = false
        this.showBulkTypeWeek = true
      }
    },
    async dateChanged (date) {
      if (this.bulkType === this.BULKTYPE_DAY) {
        if (this.updateColumnName === 'originDate') {
          this.originDate = date.format('Y-MM-DD')
        } else if (this.updateColumnName === 'targetStartDate') {
          this.targetStartDate = date.format('Y-MM-DD')
          if (this.targetEndDate < date.format('Y-MM-DD')) {
            this.targetEndDate = date.format('Y-MM-DD')
          }
        } else if (this.updateColumnName === 'targetEndDate') {
          this.targetEndDate = date.format('Y-MM-DD')
          if (this.targetStartDate > date.format('Y-MM-DD')) {
            this.targetStartDate = date.format('Y-MM-DD')
          }
        }
      } else {
        if (this.updateColumnName === 'originDateForWeek') {
          this.originDateForWeek = this.calcMonthDate(date).format('Y-MM-DD')
        } else if (this.updateColumnName === 'targetWeekDate') {
          this.targetWeekDate = this.calcMonthDate(date).format('Y-MM-DD')
        }
      }

      if (this.showModal) {
        this.showModal = false
      }
    },
    openBulkForm () {
      alert('open!')
    },
    handleClickHelpCalendarModal (name) {
      this.updateColumnName = name
      this.showModal = true
    },
    handlecloseHelpCalendarModal () {
      this.showModal = false
    },
    handleClickBulkForm () {
      if (this.showConfirmingChangeDialog()) {
        this.showBulkSettingForm = true
      }
    },
    handleCloseBulkForm () {
      this.showBulkSettingForm = false
      this.showBulkTypeDay = false
      this.showBulkTypeWeek = false
      this.bulkType = ''
    },
    async handleBulkCopyBooking () {
      let isNG = false
      if (this.bulkType === this.BULKTYPE_DAY) {
        if (moment().format('Y-MM-DD') > moment(this.targetStartDate).format('Y-MM-DD')) {
          isNG = true
        }
      } else if (this.bulkType === this.BULKTYPE_WEEK) {
        if (moment().format('Y-MM-DD') > moment(this.targetWeekDate).format('Y-MM-DD')) {
          isNG = true
        }
      }
      if (isNG) {
        alert('コピー先の日付に過去を選択できません。')
        return
      }

      this.$confirm('コピー先のもともとの設定を破棄後、コピーします。本当にコピーしますか？', '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.bulkCopy()
      }).catch(() => {})
    },
    async bulkCopy () {
      let originDates = []
      let targetStartDate = ''
      let targetEndDate = ''
      if (this.bulkType === this.BULKTYPE_DAY) {
        originDates.push(this.originDate)

        targetStartDate = moment(this.targetStartDate).format('Y-MM-DD')
        targetEndDate = moment(this.targetEndDate).format('Y-MM-DD')
      } else if (this.bulkType === this.BULKTYPE_WEEK) {
        originDates = []
        const start = moment(this.originDateForWeek)
        const end = moment(this.originDateForWeek).add(6, 'd')
        while (start.diff(end) <= 0) {
          originDates.push(start.format('Y-MM-DD'))
          start.add(1, 'd')
        }

        targetStartDate = moment(this.targetWeekDate).format('Y-MM-DD')
        targetEndDate = moment(this.targetWeekDate).add(this.weekCount, 'w').add(-1, 'd').format('Y-MM-DD')
      }

      this.loadingListBookingTable = true
      const pharID = this.pharmacy.id

      if (originDates.length > 0 && targetStartDate && targetEndDate) {
        await CalendarApi.bulkCopyPharmacyCalendar({
          originDates, targetStartDate, targetEndDate
        }, pharID)
          .catch((error) => {
            apiErrorDialog(this, error)
          })
      }

      // this.$router.go({path: this.$router.currentRoute.path, force: true})
      this.$emit('afterCopy', moment(targetStartDate))
      this.loadingListBookingTable = false
      this.handleCloseBulkForm()
    },
    showConfirmingChangeDialog () {
      let isOk = true
      if (this.isChanged) {
        isOk = window.confirm('受付枠の設定が変更されましたが保存されていません。設定内容を破棄してもよろしいですか？')
        if (isOk) {
          this.$emit('resetChangeSatus')
        }
      }
      return isOk
    }
  },
  async mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BulkSettings.vue